
export default {
  name: 'PagesAboutExtentionsBusinessCreateProfile',
  data() {
    return {
      checkedGifts: [],
      maxGifts: 1,
      blockServices: [],
    }
  },
  computed: {
    moduleFunc() {
      return this.$store?.getters['settings/getModuleById']
    },
    freeServices() {
      const allServices = this.$store.getters['settings/getServices']

      const freeServices = allServices.filter(
        (service) => !service.price || service.price === 0
      )

      return freeServices
    },
    gifts() {
      const allGifts = this.$store.getters['settings/getGifts']

      const gifts = allGifts.filter((gift) => gift.inRegister)

      return gifts
    },
  },
  methods: {
    modulesByFreeServices() {
      const modules = []
      for (const service of this.freeServices) {
        const module = this.moduleFunc(service.module)
        if (module) {
          modules.push(module)
        }
      }
      return [...new Set(modules)]
    },

    moduleServices(id) {
      return this.freeServices.filter((service) => service.module === id)
    },
    giftsByIds() {
      return this.gifts.filter((gift) => this.checkedGifts.includes(gift._id))
    },
    onRegister() {
      this.$router.push({
        name: 'register-type',
        params: {
          type: 'company',
          data: {
            from: 'Со страницы О нас | Для бизнеса',
            services: this.freeServices,
            gifts: this.giftsByIds(),
          },
        },
      })
    },
  },
}
